import { IUser } from 'src/@types/user';
import { PostHog } from '../analytics/posthog';
import { SentryInstance } from './instance';

export const identify = (user: IUser) => {
  SentryInstance.setUser({ id: user._id, name: user.name });
};

export const captureError: typeof SentryInstance.captureException = (
  error,
  hint,
) => {
  SentryInstance.addBreadcrumb({
    message: `Posthog recording`,
    level: 'debug',
    data: {
      session_replay: PostHog.getRecordURL(),
    },
  });
  return SentryInstance.captureException(error, hint);
};

export const captureMessage = (message: string) => {
  SentryInstance.captureMessage(message);
};

/**
 * Use this function to capture breadcrumbs in SentryInstance.
 * Report relevant user actions or system events.
 *
 * @param feat  The feature that the breadcrumb is related to.
 * @param level  The level of the breadcrumb.
 * @param message  The message to be captured.
 */
export const capture = (
  feat:
    | 'voiceChannel'
    | 'textChannel'
    | 'board'
    | 'todo'
    | 'doc'
    | 'auth'
    | 'settings'
    | 'meet',
  level: 'info' | 'warning' | 'error',
  message: string,
  data?: Record<string, any>,
) => {
  SentryInstance.addBreadcrumb({
    category: feat,
    message,
    level,
    data,
  });
};
